/*@flow*/
import type { Node } from 'react';
import React, { useReducer } from 'react';
import reducer from './reducer';
import BuilderContext from './Context';
import mkState from './mkState';

const Component = (props: { children: React$Node }): Node => {
  const [state, dispatch] = useReducer(reducer, mkState());
  const ctx = { state, dispatch };
  return (
    <BuilderContext.Provider value={ctx}>
      {props.children}
    </BuilderContext.Provider>
  );
};

export default Component;

export function hocShell<T>(
  Child: React$ComponentType<T>
): React$StatelessFunctionalComponent<T> {
  return (props: T) => (
    <Component>
      <Child {...props} />
    </Component>
  );
}
